import { render } from "./UpdateUser.vue?vue&type=template&id=58fc035c&scoped=true"
import script from "./UpdateUser.vue?vue&type=script&lang=js"
export * from "./UpdateUser.vue?vue&type=script&lang=js"

import "./UpdateUser.vue?vue&type=style&index=0&id=58fc035c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58fc035c"

export default script